import React from "react";
import { isCompositeTypeElement } from "../../../helpers/util";
import { OnClickButton } from "../Buttons/OnClickButton";
import { SearchBoxTypes } from "../Search";

function rowFilters(filters, props) {
  {
    return filters.map((filter, index) => {
      if (React.isValidElement(filter)) {
        return <div className="col-xs-12 col-sm-6 col-md-3">
          <div className="form-col">
            <label>{filter.label} {filter.tooltip ? <i className="info-icon tooltip tooltip-bottom tooltip-xs-right pl-1" data-tooltip={filter.tooltip}> </i> : null}</label>
            {filter}
          </div>
        </div>

      }
      else return <div className="col-xs-12 col-sm-6 col-md-3">
        <div className="form-col">
          <label>{filter.label} {filter.tooltip ? <i className="info-icon tooltip tooltip-bottom tooltip-xs-right pl-1" data-tooltip={filter.tooltip}> </i> : null}</label>
          <SearchBoxTypes {...filter} onChange={props.onChange} />
        </div>
      </div>
    })
  }
}

export const SearchBox = props =>
  <div className="filter-row d-flex flex-column flex-md-row align-items-end">
    <div className="flex-1 w-100">
      {props.filters.map((filter, index) => {
        if (Array.isArray(filter)) return <div className="row row-sm">{rowFilters(filter, props)}</div>
        else return <div className="row row-sm"><div className="col-xs-12 col-sm-6 col-md-3">
          <div className="form-col">
            <label>{filter.label} {filter.tooltip ? <i className="info-icon tooltip tooltip-bottom tooltip-xs-right pl-1" data-tooltip={filter.tooltip}> </i> : null}</label>
            <SearchBoxTypes {...filter} onChange={props.onChange} />
          </div>
        </div></div>
      })}
      <div className="row row-sm">
        <OnClickButton title={props.buttonTitle} onClick={props.onClick} />
      </div>
    </div>
  </div>
